import { MDSText, MDSTextVariant, MDSTextWeight, MDSTextColor } from "@/mds";
import styled from "@emotion/styled";
import { ListBoxItem } from "react-aria-components";

interface ContactsFacetFilterNoResultsProps {
  searchText: string;
}

export const ContactsFacetFilterNoResults = ({ searchText }: ContactsFacetFilterNoResultsProps) => {
  return (
    <Wrapper>
      <MDSText
        variant={MDSTextVariant.TextS}
        weight={MDSTextWeight.Regular}
        color={MDSTextColor.Secondary}
      >
        {searchText
          ? "No results match your current search"
          : "You haven't shared any notes with anyone yet"}
      </MDSText>
    </Wrapper>
  );
};

const Wrapper = styled(ListBoxItem)`
  padding-inline: ${({ theme }) => theme.spacing["5"]};
  padding-block: ${({ theme }) => theme.spacing["2"]};
`;
